import * as React from 'react';
import { useState } from 'react';
import { View as RNView } from 'react-native';
import {
    BodyMediumRegular,
    DEFAULT_ICON,
    FruitfulCustomIcon,
    H5Emphasized,
    View,
    YStack,
} from 'smoothie';

import type { UpdateBankAccountInfo } from '../../../../types/BankAccount';
import CreateEditButton from './CreateEditButton';
import IconSelection from './IconSelection';

interface IconProps {
    onPressNext: (updates?: Partial<UpdateBankAccountInfo>) => void;
    accountInfo: UpdateBankAccountInfo;
}

const Icon = ({ onPressNext, accountInfo }: IconProps) => {
    const [icon, setIcon] = useState(accountInfo.icon);

    return (
        <YStack flex={1} justifyContent="space-between">
            <View>
                <H5Emphasized textAlign="center" marginVertical={12}>
                    Customize your space
                </H5Emphasized>
                <BodyMediumRegular
                    textAlign="center"
                    color="$gray1100"
                    marginBottom={36}
                >
                    Personalize your savings space based on its purpose
                </BodyMediumRegular>
                <View alignSelf="center">
                    <FruitfulCustomIcon
                        icon={icon}
                        color={accountInfo.color}
                        size="xl"
                        showShadow
                    />
                </View>
                <H5Emphasized textAlign="center" marginTop={24}>
                    {accountInfo.nickname}
                </H5Emphasized>
            </View>
            {/* IconSelect has a TabView which cannot be rendered in Tamagui stack components, so use a basic beans native view */}
            <RNView
                style={{
                    flex: 1,
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                }}
            >
                <IconSelection
                    selectedIcon={icon ?? DEFAULT_ICON}
                    onSelect={(icon) => {
                        setIcon(icon);
                    }}
                />
                <CreateEditButton
                    disabled={icon == null}
                    onPress={() => {
                        onPressNext({ icon });
                    }}
                />
            </RNView>
        </YStack>
    );
};

export default Icon;
